module.exports = __webpack_public_path__ + "static/img/living_5.13adf8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/living_5.jpg
// module id = /Evi
// module chunks = 3